import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
const Wrapper = styled.div `
  padding: 0;
  height: 100%;
  width: 100%;
  position: relative;
  overflow: hidden;
`;
const Cover = styled.ul `
  height: calc(100% + 17px);
  padding: 0 0 17px 0;
  margin: 0 -10px -17px;
  display: flex;
  position: relative;
  overflow: auto;
`;
const Nav = ({ children }) => (_jsx(Wrapper, { children: _jsx(Cover, { children: children }) }));
export default React.memo(Nav);
